// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1FsSq","newExpiryDate":"styles_newExpiryDate__1aZCN","footer":"styles_footer__1rH6a"};